// @flow
// $FlowFixMe
import React, { useCallback, useMemo } from "react";
import { noop, get } from "lodash";
import type { BinaryFn } from "@tvg/types/Functional";
import type { RaceWagerType } from "@tvg/types/Race";
import {
  WagerType,
  WagerDescription,
  WagerTypeContainer,
  DescriptionWrapper
} from "./styled-components";
import Button from "../../_atoms/ButtonDefault";

type Props = {
  onWagerTypeClick: BinaryFn<RaceWagerType, number, void>,
  wagerType: RaceWagerType,
  activeWagerType: number,
  country: string,
  showTypeName: boolean
};

const getDescription = (
  showTypeName: boolean,
  isNationalRace: boolean,
  wagerType: RaceWagerType
) => {
  let description = get(wagerType, `type.description`, "");
  if (!isNationalRace) {
    description =
      get(
        wagerType,
        `${showTypeName ? "type" : "group"}.descriptionInternational`
      ) || description;
  }
  return description;
};

const WagerSelector = (props: Props) => {
  const {
    onWagerTypeClick,
    wagerType,
    activeWagerType,
    country,
    showTypeName
  } = props;

  const isActive = useCallback(
    () => activeWagerType === wagerType.type.id,
    [activeWagerType]
  )();
  const isNationalRace = country === "USA" || country === "US";
  return useMemo(
    () => (
      <WagerTypeContainer
        data-qa-label={`wager-type-${wagerType.type.name.replace(
          " ",
          "-"
        )}`.toLowerCase()}
      >
        <Button onClick={() => onWagerTypeClick(wagerType, activeWagerType)}>
          <DescriptionWrapper isActive={isActive}>
            <WagerType isActive={isActive}>
              {showTypeName ? wagerType.type.name : wagerType.group.name}
            </WagerType>
            <WagerDescription>
              {getDescription(showTypeName, isNationalRace, wagerType)}
            </WagerDescription>
          </DescriptionWrapper>
        </Button>
      </WagerTypeContainer>
    ),
    [isActive, activeWagerType]
  );
};

WagerSelector.defaultProps = {
  onWagerTypeClick: noop,
  wagerType: {},
  activeWagerType: 0,
  country: "",
  showTypeName: false
};

export default WagerSelector;
